import React, { useCallback, useEffect, useState } from 'react';
import AppLayout from '../../../../component/appLayout';
import { useMobileDevice } from '../../../../global/useMobile';
import { Container, Group, Header, PersonalText } from '../../styles';
import ResponsiveHeader from '../../../../component/responsiveHeader';
import Button from '../../../../component/button';
import { BUTTON_TYPE, EMPTY_STATE_SIZE, ICON_SIZE } from '../../../../global/constants';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import { ActionDiv, ButtonSection, IconDiv, MainSection, TableDiv } from './styles';
import { getTeamcampAIData } from '../../../../services/settingServices';
import { rootStore } from '../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { isEmpty } from '../../../../helpers/common';
import AiLogLoading from '../../../../component/loading/aiLogLoading';
import { captureException } from '../../../../services/logService';
import BottomSubNavigation from '../../../../component/bottomNavigation/subNavigation';
import EmptyStateV2 from '../../../../component/emptyState';

const PAGE_LIMIT = 30;

const TeamcampAi = () => {
  // state variables
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  //Mobx store variables
  const { settingStore, workspaceStore } = rootStore || {};
  const { currentWorkspace: workspace } = workspaceStore || {};
  const { teamcampAIData } = settingStore || {};
  // other variables
  const isMobile = useMobileDevice();

  const loadData = useCallback(
    async (pageNum: number, isAppend: boolean = false) => {
      try {
        setLoading(true);
        if (!isEmpty(workspace?.id)) {
          // Fetch AI usage datafrom API
          const data = await getTeamcampAIData(pageNum, PAGE_LIMIT, isAppend);
          if (data && data.length === PAGE_LIMIT) {
            setHasMore(true);
          } else {
            setHasMore(false);
          }
        }
      } catch (error) {
        captureException(error);
      } finally {
        setLoading(false);
      }
    },
    [workspace?.id]
  );

  useEffect(() => {
    loadData(1, false);
    setPage(1);
  }, [loadData]);

  const handleLoadMore = async () => {
    const nextPage = page + 1;
    await loadData(nextPage, true);
    setPage(nextPage);
  };

  return (
    <>
      <AppLayout isPosition={true}>
        <Container>
          <Group>
            {!isMobile ? (
              <Header>
                <PersonalText>Teamcamp AI</PersonalText>
                {false && (
                  <ActionDiv>
                    <Button
                      title='7.36 Credits'
                      iconName='credit-icon'
                      iconViewBox={`0 0 ${ICON_SIZE.SM} ${ICON_SIZE.SM}`}
                      variant={BUTTON_TYPE.SECONDARY}
                      buttonType='button'
                      onClick={() => {}}
                      size='small'
                    />
                    <IconDiv>
                      <SVGIcon
                        name='three-dots-horizontal-icon'
                        width={ICON_SIZE.MD}
                        height={ICON_SIZE.MD}
                        viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                      />
                    </IconDiv>
                  </ActionDiv>
                )}
              </Header>
            ) : (
              <ResponsiveHeader title='Teamcamp AI' />
            )}
            {/* loading state */}
            {loading && teamcampAIData?.length === 0 && <AiLogLoading />}
            {/* empty state */}
            {!loading && teamcampAIData?.length === 0 && (
              <EmptyStateV2
                size={EMPTY_STATE_SIZE.MEDIUM}
                title='No AI credits used yet'
                imageUrl='ai_log_empty'
                isAlignedCenter={true}
              />
            )}
            {teamcampAIData?.length > 0 && (
              <MainSection>
                <TableDiv>
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Time</th>
                        <th>Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      {teamcampAIData?.map((item, index) => (
                        <tr key={`${item.name}-${item.time}-${index}`}>
                          <td>{item.name}</td>
                          <td>{item.time}</td>
                          <td>{item.cost}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </TableDiv>
                {hasMore && (
                  <ButtonSection>
                    <Button
                      variant={BUTTON_TYPE.SECONDARY}
                      buttonType='button'
                      title='Load More'
                      size='small'
                      onClick={handleLoadMore}
                      disabled={loading}
                    />
                  </ButtonSection>
                )}
              </MainSection>
            )}
          </Group>
        </Container>
      </AppLayout>
      <BottomSubNavigation />
    </>
  );
};

export default observer(TeamcampAi);
